<template>
  <div
    class="thank-you section"
    :style="sectionStyle"
  >
    <div
      v-if="title"
      class="text-center q-mb-xl title"
      :style="titleStyle"
      v-html="$options.filters.pureHtml(title)"
    />
    <q-no-ssr>
      <div class="flex justify-center">
        <template v-if="renderComponent.$props.isBuilder">
          <ThankYouWidget
            v-if="form"
            :translation="translation[form.settings.language]"
            :full-form="form"
            :lang="form.settings.language"
          />
        </template>
        <FormRender
          v-else
          :form-guid="formGuid"
          :override-options="overrideOptions"
          only-thank-you
        />
      </div>
    </q-no-ssr>
  </div>
</template>

<script>
import { transformObjectToFormState } from 'common/helpers/formStore';
import FormRender from 'common/render/FormRender';
import ThankYouWidget from 'common/render/ThankYouWidget';
import TRANSLATIONS from 'common/translations.json';
import { debounce } from 'quasar';
import backgroundMixin from './mixins/backgroundMixin';
import titleMixin from './mixins/titleMixin';

export default {
  name: 'ThankYouSection',
  components: { ThankYouWidget, FormRender },
  mixins: [backgroundMixin, titleMixin],
  props: {
    thankYouPageWidgetsType: {
      type: String,
      default: undefined,
    },
    thankYouPageWidgetsFirstAreaBackgroundColor: {
      type: String,
      default: undefined,
    },
    thankYouPageWidgetsSecondAreaBackgroundColor: {
      type: String,
      default: undefined,
    },
    thankYouPageWidgetsBorderRadius: {
      type: Number,
      default: undefined,
    },
    thankYouPageWidgetsHead: {
      type: Boolean,
      default: undefined,
    },
    thankYouPageWidgetsLinkToEvent: {
      type: Boolean,
      default: undefined,
    },
    thankYouPageWidgetsJoinButton: {
      type: Boolean,
      default: undefined,
    },
    thankYouPageWidgetsAddToCalendar: {
      type: Boolean,
      default: undefined,
    },
    thankYouPageWidgetsReverseTimer: {
      type: Boolean,
      default: undefined,
    },
    thankYouPageWidgetsEventDate: {
      type: Boolean,
      default: undefined,
    },
    thankYouPageWidgetsPhoneFieldEnabled: {
      type: Boolean,
      default: undefined,
    },
  },
  data() {
    return {
      form: undefined,
    };
  },
  computed: {
    translation: () => TRANSLATIONS,
    renderComponent() {
      return this.$parent.$parent;
    },
    designOptions() {
      return this.renderComponent.$props.options.designOptions;
    },
    formGuid() {
      return this.renderComponent.$props.formGuid;
    },
    overrideOptions() {
      return {
        hasPopup: false,
        thankYouPageWidgetsType: this.thankYouPageWidgetsType,
        thankYouPageWidgetsFirstAreaBackgroundColor: this.thankYouPageWidgetsFirstAreaBackgroundColor,
        thankYouPageWidgetsSecondAreaBackgroundColor: this.thankYouPageWidgetsSecondAreaBackgroundColor,
        thankYouPageWidgetsBorderRadius: this.thankYouPageWidgetsBorderRadius,
        thankYouPageWidgetsHead: this.thankYouPageWidgetsHead,
        thankYouPageWidgetsLinkToEvent: this.thankYouPageWidgetsLinkToEvent,
        thankYouPageWidgetsJoinButton: this.thankYouPageWidgetsJoinButton,
        thankYouPageWidgetsAddToCalendar: this.thankYouPageWidgetsAddToCalendar,
        thankYouPageWidgetsReverseTimer: this.thankYouPageWidgetsReverseTimer,
        thankYouPageWidgetsEventDate: this.thankYouPageWidgetsEventDate,
        thankYouPageWidgetsPhoneFieldEnabled: this.thankYouPageWidgetsPhoneFieldEnabled,
        thankYouPageWidgetsJoinButtonBackgroundColor: this.designOptions.activeColor,
        thankYouPageWidgetsJoinButtonBorderColor: this.designOptions.activeColor,
        thankYouPageWidgetsPhoneButtonBackgroundColor: this.designOptions.activeColor,
      };
    },
  },
  watch: {
    overrideOptions: {
      deep: true,
      immediate: true,
      handler: debounce(function () {
        if (this.renderComponent.$props.isBuilder) {
          this.fetch();
        }
      }, 500),
    },
  },
  methods: {
    async fetch() {
      const { data } = await this.$axios.get(`public/forms/${this.formGuid}.json`, {
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
        },
      });
      // await this.getIcons(data.data);
      const form = data.data;
      if (this.overrideOptions) {
        Object.keys(this.overrideOptions)
          .filter((key) => this.overrideOptions[key] !== undefined)
          .forEach((key) => {
            form[key] = this.overrideOptions[key];
          });
      }
      this.form = await transformObjectToFormState(form);
    },
  },
};
</script>
